// Returns a record's cover image URL, or a branded placeholder when none is set, so
// articles/games without a cover render intentionally instead of as a broken/empty <img>
// (or, for background-image heroes, a bare grey block). Accepts any record with an
// optional `coverImage.url` (articles, games, etc.).
export const FALLBACK_COVER = '/img/cover-fallback.svg';

// Absolute, raster fallback for contexts that need a fully-qualified URL fetched
// out-of-page — chiefly og:image, which social scrapers resolve against the
// origin (a relative path won't work) and which many platforms won't render as
// SVG. Domain matches the hardcoded canonical URLs in the post routes.
export const FALLBACK_COVER_OG = 'https://1vX.gg/img/cover-fallback.png';

export function coverUrl(record) {
  return record?.coverImage?.url || FALLBACK_COVER;
}

// Cover URL suitable for og:image: the record's cover if present, else the
// absolute branded placeholder.
export function ogCoverUrl(record) {
  return record?.coverImage?.url || FALLBACK_COVER_OG;
}

export default coverUrl;
